import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import useTheme from '../hooks/useTheme';

function ControlPanel({ onExit, submitEnabled = true }) {
  const { submitForm } = useFormikContext();
  const [theme] = useTheme();

  const handleSubmit = () => {
    (async () => submitForm())();
  };
  return (
    <div style={{ float: 'right' }}>
      <Button
        type="submit"
        style={{ marginRight: '.15em' }}
        size="lg"
        onClick={handleSubmit}
        disabled={!submitEnabled}
        variant={theme?.buttonVariant}
      >
        SAVE
      </Button>
      <Button size="lg" onClick={onExit} variant={theme?.buttonVariant}>
        EXIT
      </Button>
    </div>
  );
}

ControlPanel.propTypes = {
  onExit: PropTypes.func,
  submitEnabled: PropTypes.bool,
};
export default ControlPanel;
